import axios from 'axios';
import apiConfig from '../../api.config';

export default function activateOtaAccountRequest({ email, hotelSlug }) {
  const {
    host,
    URIs: { auth },
  } = apiConfig;

  const uri = `${host}${auth.activateOtaAccount}`;

  return axios
    .post(uri, JSON.stringify({ email, hotelSlug }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
